import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import {
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon,
  SettingsBrightness as AutoModeIcon,
} from '@mui/icons-material';
import { useThemeMode } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { mode, toggleMode } = useThemeMode();

  const getIcon = () => {
    switch (mode) {
      case 'light':
        return <LightModeIcon />;
      case 'dark':
        return <DarkModeIcon />;
      case 'system':
        return <AutoModeIcon />;
      default:
        return <AutoModeIcon />;
    }
  };

  const getTooltip = () => {
    switch (mode) {
      case 'light':
        return 'Light mode - Click for dark mode';
      case 'dark':
        return 'Dark mode - Click for system preference';
      case 'system':
        return 'System preference - Click for light mode';
      default:
        return 'Toggle theme';
    }
  };

  return (
    <Tooltip title={getTooltip()}>
      <IconButton
        onClick={toggleMode}
        color="inherit"
        sx={{
          transition: 'transform 0.3s ease-in-out',
          '&:hover': {
            transform: 'rotate(20deg)',
          },
        }}
      >
        {getIcon()}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
